import { Injectable } from '@angular/core';
// import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Negocio } from './negocio';
import { map } from 'rxjs/operators';
import * as myGlobals from './../global';
import { HttpClientSecured } from '../services/http-client-secured';

@Injectable({
  providedIn: 'root'
})
export class NegociosService {
  private _negociosURL = myGlobals.baseApi + '/webadmin/v1/business';

  constructor(private http: HttpClientSecured) {}

  allRecords() {
    return this.http.get<any>(this._negociosURL);
  }

  getBusiness(id: number): Observable<Negocio | undefined> {
    return this.allRecords().pipe(map((negocios: Negocio[]) => negocios.find(p => p.id === id)));
  }
}
